import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { ProfilDetails } from 'src/app/model/profilDetails';
import { UpdateProfil } from 'src/app/model/updateProfil';
import { AuthService } from 'src/app/modules/auth/services/auth.service';

@Component({
  selector: 'app-edit-profil',
  templateUrl: './edit-profil.component.html',
  styleUrls: ['./edit-profil.component.css'],
})
export class EditProfilComponent implements OnInit {
  editProfileForm!: FormGroup;

  portfolio!: any;

  statutProfessionnels!: any;
  experiences!: any;
  diplomes!: any;
  specialisations!: any;
  objectToUpdate!: UpdateProfil;
  user!: any;
  profil!: any;
  profil1!: any;
  //-----------
  token: any;
  logged: any;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {
    this.editProfileForm = this.formBuilder.group({
      selectedDescription: [''],
      fonction: ['', Validators.required],
      selectedProfil: [''],
      selectedExperience: [''],
      selectedDiplome: [''],
      selectedSpecialisation: [''],
    });
    this.user = sessionStorage.getItem('user');
    // this.portfolio = JSON.parse(this.user).portfolio;
    // //console.log('Mon portfolio:', this.portfolio);

    //-----------------------
    this.token = sessionStorage.getItem('isUserLoggedIn');
    // console.log('le token  est :', this.token);
    this.user = sessionStorage.getItem('user');
    this.logged = sessionStorage.getItem('logged');

    if (this.logged != 'true' || this.logged === undefined) {
      this.router.navigate(['auth/login']);
    } else {
      this.profil1 = JSON.parse(this.user).profile.id;
    }
  }

  ngOnInit(): void {
    let tk = this.token;
    this.portfolio = this.authService
      .getPortfolio(JSON.parse(this.user).iuf)
      .subscribe((Response) => {
        // console.log(Response);
        if (Response.status == 200) {
          if (Response.object != null) {
            this.portfolio = Response.object;

            this.editProfileForm.patchValue({
              selectedDescription:
                this.portfolio.a_monsujet != null
                  ? this.portfolio.a_monsujet
                  : null,
              fonction:
                this.portfolio.profil != null ? this.portfolio.profil : null,
              selectedProfil:
                this.portfolio.statut_pro != null
                  ? this.statutProfessionnels[
                      this.getSatutProId(this.portfolio.statut_pro)
                    ].name
                  : null,
              selectedExperience:
                this.portfolio.experience != null
                  ? this.experiences[
                      this.getExperienceId(this.portfolio.experience)
                    ].name
                  : null,
              selectedDiplome:
                this.portfolio.high_diploma != null
                  ? this.diplomes[
                      this.getDiplomeId(this.portfolio.high_diploma)
                    ].name
                  : null,
              selectedSpecialisation:
                this.portfolio.domaine_specialisation != null
                  ? this.specialisations[
                      this.getSpecialisationId(
                        this.portfolio.domaine_specialisation
                      )
                    ].name
                  : null,
            });
          }
        }
      });
    this.statutProfessionnels = ProfilDetails.statutProfessionnels;
    this.experiences = ProfilDetails.Experiences;
    this.diplomes = ProfilDetails.Diplomes;
    this.specialisations = ProfilDetails.Specialisations;
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  onSubmitForm() {
    const formValue = this.editProfileForm.value;

    const profilToupdate = new UpdateProfil(
      formValue['fonction'],
      formValue['selectedProfil'],
      formValue['selectedExperience'],
      formValue['selectedDiplome'],
      formValue['selectedSpecialisation'],
      formValue['selectedDescription']
    );

    //console.log(profilToupdate);
    // //console.log(JSON.parse(this.user).iuf);

    this.authService
      .updatePortfolio(JSON.parse(this.user).iuf, profilToupdate)
      .subscribe((Response) => {
        //console.log(Response);
        if (Response.status == 200) {
          // this.authService.getPortfolio(JSON.parse(this.user).iuf);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      });
  }

  getSatutProId(name: string): number {
    let correctId: any;
    this.statutProfessionnels.forEach((element: any) => {
      if (element.name === name) {
        correctId = element.id;
      }
    });
    return correctId;
  }

  getExperienceId(name: string): number {
    let correctId: any;
    this.experiences.forEach((element: any) => {
      if (element.name === name) {
        correctId = element.id;
      }
    });
    return correctId;
  }

  getDiplomeId(name: string): number {
    let correctId: any;
    this.diplomes.forEach((element: any) => {
      if (element.name === name) {
        correctId = element.id;
      }
    });
    return correctId;
  }
  getSpecialisationId(name: string): number {
    let correctId: any;
    this.specialisations.forEach((element: any) => {
      if (element.name === name) {
        correctId = element.id;
      }
    });
    return correctId;
  }
}
